enum View {
    GRID = 'GRID',
    LIST = 'LIST'
}

export default View;